import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";

export const CookiePolicyDialog = ({ children }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        className="max-w-lg max-h-[80vh] overflow-y-auto bg-crema border-espresso/15"
        data-testid="cookie-policy-dialog"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-espresso">
            Cookie Policy
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm leading-relaxed text-stone mt-2">
          <p>
            Informativa sui cookie ai sensi del Regolamento UE 2016/679 (GDPR) e della
            Direttiva ePrivacy, per il sito alinacossali.it della Ditta Individuale{" "}
            <span className="text-espresso font-medium">Alina Cossali</span> — P.IVA
            04494520168, C.F. CSSLNA86C56C800I, Via Pos Palì 2, 24020 Parre (BG).
          </p>
          <div>
            <p className="text-espresso font-medium mb-1">Cosa sono i cookie</p>
            <p>
              I cookie sono piccoli file di testo che i siti salvano sul tuo dispositivo
              per funzionare correttamente o raccogliere informazioni. Esistono cookie
              tecnici (necessari) e cookie di profilazione/analisi (che richiedono il tuo
              consenso).
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Cookie utilizzati da questo sito</p>
            <p>
              Questo sito utilizza <strong className="text-espresso">esclusivamente cookie e
              strumenti tecnici</strong>, senza i quali non potrebbe funzionare:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1.5">
              <li>
                <strong className="text-espresso">Cookie di sessione dell'area riservata</strong>{" "}
                (session_token): mantiene l'accesso della titolare al pannello di
                amministrazione. Durata: 7 giorni.
              </li>
              <li>
                <strong className="text-espresso">Memoria del consenso cookie</strong>: conserva
                la scelta che hai espresso in questo banner, per non mostrartelo a ogni
                visita.
              </li>
              <li>
                <strong className="text-espresso">Dati temporanei di iscrizione alla
                Masterclass</strong>: conservati solo nel tuo browser durante il passaggio
                tra il modulo di iscrizione e la scelta dell'orario della call; si
                cancellano al termine.
              </li>
            </ul>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Nessun cookie di profilazione</p>
            <p>
              Il sito <strong className="text-espresso">non installa cookie di analisi,
              statistiche, marketing o profilazione</strong> (né propri né di terze parti).
              Non essendoci cookie non tecnici, nessun tracciamento viene attivato né prima
              né dopo il tuo consenso.
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Servizi esterni collegati</p>
            <p>
              Il sito contiene link verso servizi esterni (WhatsApp, Instagram, Zoom,
              Google Calendar). Visitandoli, questi soggetti possono installare cookie
              propri secondo le rispettive informative, sulle quali il Titolare non ha
              controllo.
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Come gestire o revocare il consenso</p>
            <p>
              Puoi modificare la tua scelta in qualsiasi momento dal link{" "}
              <strong className="text-espresso">"Preferenze cookie"</strong> nel footer di ogni
              pagina: il banner ti verrà riproposto. Puoi inoltre cancellare i cookie dal
              tuo browser tramite le impostazioni di navigazione.
            </p>
          </div>
          <div>
            <p className="text-espresso font-medium mb-1">Titolare e contatti</p>
            <p>
              Per qualsiasi domanda:{" "}
              <a href="mailto:info@alinacossali.it" className="text-fuchsiabrand underline">
                info@alinacossali.it
              </a>
              .
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
